module.exports = __webpack_public_path__ + "img/827.de93d0e2.png";